// Stronger Dark Mode Button for Shopify
function initDarkMode() {
  console.log('Dark mode init running');

  // Remove existing button if any
  const existing = document.querySelector('.dark-mode-toggle');
  if (existing) existing.remove();

  const toggle = document.createElement('button');
  toggle.className = 'dark-mode-toggle';
  toggle.setAttribute('aria-label', 'Toggle dark mode');
  toggle.innerHTML = '🌙';
  document.body.appendChild(toggle);

  // Check current state
  const isDark = document.documentElement.classList.contains('dark-mode');
  if (isDark) {
    toggle.innerHTML = '☀️';
  }

  toggle.addEventListener('click', function () {
    const nowDark = document.documentElement.classList.toggle('dark-mode');
    
    if (nowDark) {
      toggle.innerHTML = '☀️';
      localStorage.setItem('darkMode', 'true');
    } else {
      toggle.innerHTML = '🌙';
      localStorage.setItem('darkMode', 'false');
    }
  });
}

// Run when page loads
document.addEventListener('DOMContentLoaded', initDarkMode);

// Also run after dynamic content loads (important for Shopify)
window.addEventListener('load', initDarkMode);
setTimeout(initDarkMode, 800);   // Extra safety